// eslint-disable-next-line no-restricted-imports
import { PaidAccountModel, PaidAccountResponse } from 'types';

import genericNormalizer from './generic';

export const normalizePaidAccount = genericNormalizer<
  PaidAccountResponse,
  PaidAccountModel
>(({ from }) => ({
  standing: from('standing'),
}));



// WEBPACK FOOTER //
// ./app/gamma/src/api/normalizers/account.ts